import { IconComponent } from '@wwt/entities/base'

import { TooltipIconDetails } from '../types/TooltipIconDetails'
import { TooltipIconsList } from '../ui/TooltipIconsList'

interface ToolTipWithIconProps {
	icon: IconComponent
	tooltipIconsDetails?: TooltipIconDetails[]
	title?: string
	text?: string
}

export const ToolTipWithIcon = ({
	title,
	text,
	icon: Icon,
	tooltipIconsDetails
}: ToolTipWithIconProps) => {
	if (title && text) {
		return (
			<div className="flex max-w-[20rem] min-w-[11.375rem] flex-col gap-4">
				<div className="flex h-12 w-12 items-center justify-center rounded-full border border-gray-200">
					<Icon className="h-6 w-6" />
				</div>

				<div className="flex flex-col gap-3">
					<div className="ts-2">{title}</div>
					<p className="ts-7 text-left whitespace-pre-line text-gray-600">
						{text}
					</p>
					<TooltipIconsList
						tooltipIconsDetails={tooltipIconsDetails}
						showSeparator={true}
					/>
				</div>
			</div>
		)
	}

	return (
		<div className="flex max-w-[20rem] min-w-[11.375rem] flex-col gap-4">
			<TooltipIconsList
				tooltipIconsDetails={tooltipIconsDetails}
				showSeparator={false}
			/>
		</div>
	)
}
